import FormFields from "./SignUp-SignIn/FormFields";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Grid,
  Paper,
  Stack,
  styled,
  Typography
  } from "@mui/material";
import { resetPasswordFieldsList } from "./SignUp-SignIn/fieldsLists";
import { ResetPasswordFormProps } from "../../interfaces/ISginUpSignInForm";
import { useNavigationHelper } from "../../hooks/useNavigationHelper";

const Container = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

export default function ResetPasswordForm({
  formData,
  formErrors,
  onChange,
  onClick,
  loading,
  error,
  emailSend = false,
}: ResetPasswordFormProps) {
  const { goToMainRoot } = useNavigationHelper();
  return (
    <Container>
      <Grid container height="100vh" justifyContent="center" alignItems="center">
        <Grid item>
          <Paper sx={{ p: 3, minWidth: "400px" }}>
            <Grid container direction="column" height="auto" alignItems="center" spacing={2}>
              <Grid item xs={12} textAlign="center">
                <Typography variant="h5">Zresetuj hasło</Typography>
              </Grid>
              <Grid item xs={12} width="100%">
                <FormFields
                  fieldDirection="column"
                  formData={formData}
                  formErrors={formErrors}
                  fieldsList={resetPasswordFieldsList}
                  onChange={onChange}
                />
              </Grid>
              <Grid item xs={12}>
                {error && (
                  <Typography color="error" variant="body1" fontWeight={700}>
                    {error}
                  </Typography>
                )}
                {emailSend && (
                  <Stack direction="column" spacing={1} sx={{ textAlign: "center" }}>
                    <Typography color="green" variant="body1" fontWeight={700}>
                      Instrukcja resetowania hasła została wysłana na podany adres mailowy.
                      <br />
                      Wniektórych przypadkach email może być dostarczony po kilku minutach.
                    </Typography>
                    <Typography color="green" variant="body1" fontWeight={700}>
                      Jeśli nie widzisz emaila, sprawdź folder spam lub skrzynkę pocztową.
                    </Typography>
                  </Stack>
                )}
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row" spacing={1} justifyContent="center" sx={{ width: "100%" }}>
                  {!emailSend && (
                    <LoadingButton
                      variant="contained"
                      onClick={onClick}
                      loading={loading}
                      sx={{ flex: 1, minWidth: "160px", whiteSpace: "nowrap" }}
                    >
                      Zresetuj hasło
                    </LoadingButton>
                  )}
                  <Button
                    variant="contained"
                    onClick={() => goToMainRoot()}
                    disabled={loading}
                    sx={
                      emailSend
                        ? { width: "100%", maxWidth: "300px", whiteSpace: "nowrap" }
                        : { flex: 1, minWidth: "160px", whiteSpace: "nowrap" }
                    }
                  >
                    Wróć do logowania
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
